<div class="tracking-side-element" #controlsRef>
  @if (selectors) {
    <form class="filters" [formGroup]="form">
      <app-multiselect-autocomplete
        [form]="form"
        [filter]="selectors.clientName"
        [name]="'Account Name'"
        (clearFilter)="clearFilter($event, selectors.clientName)"
        (setFilter)="dispatchFilters()"
        [loading]="isLoading"
      ></app-multiselect-autocomplete>
      <app-multiselect-autocomplete
        [form]="form"
        [filter]="selectors.year"
        [name]="'Year'"
        (clearFilter)="clearFilter($event, selectors.year)"
        (setFilter)="dispatchFilters()"
        [loading]="isLoading"
      ></app-multiselect-autocomplete>
      <section class="more-options_ranges">
        <div class="range_inputs">
          <mat-label class="range_label"> {{ inceptionInterval.name }}</mat-label>
          <mat-form-field
            subscriptSizing="dynamic"
            class="field interval app-bar-field app-bar-field-button app-field-bold-label"
          >
            <input
              matInput
              placeholder="Start"
              [matDatepicker]="startDate"
              [value]="minInceptionDate"
              (dateChange)="intervalChanged('min', $event.target?.value)"
            />
            <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
            <mat-datepicker #startDate></mat-datepicker>
          </mat-form-field>
          <mat-form-field
            subscriptSizing="dynamic"
            class="field interval app-bar-field app-bar-field-button app-field-bold-label"
          >
            <input
              matInput
              placeholder="End"
              [matDatepicker]="endDate"
              [value]="maxInceptionDate"
              (dateChange)="intervalChanged('max', $event.target?.value)"
            />
            <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
            <mat-datepicker #endDate></mat-datepicker>
          </mat-form-field>
        </div>
      </section>
      <app-multiselect-autocomplete
        [form]="form"
        [filter]="selectors.businessUnit"
        [name]="'Business Unit'"
        (clearFilter)="clearFilter($event, selectors.businessUnit)"
        (setFilter)="dispatchFilters()"
        [loading]="isLoading"
      ></app-multiselect-autocomplete>
      <app-multiselect-autocomplete
        [form]="form"
        [filter]="selectors.complete"
        [name]="'Complete'"
        (clearFilter)="clearFilter($event, selectors.complete)"
        (setFilter)="dispatchFilters()"
        [loading]="isLoading"
      ></app-multiselect-autocomplete>
    </form>
  }
  @if (isLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <button class="save" appButton accent (click)="savePreferences()">
    <span>Save As New View </span>
  </button>
  @if (userPreferences.length > 0 && autoSelectSavedView) {
    <button class="save" appButton accent (click)="updatePreferences()">
      <span>Update Current View </span>
    </button>
  }

  @if (userPreferences.length > 0) {
    <mat-form-field class="selector" appearance="fill">
      <mat-label>Saved Views:</mat-label>
      <mat-select
        [(value)]="selectedPreferenceValue"
        (selectionChange)="onPreferenceChange($event)"
      >
        <!-- Only show the preference name in the select -->
        <mat-select-trigger>
          {{ preferenceNames[selectedPreferenceValue] || "Preference 1" }}
        </mat-select-trigger>
        <!-- Dropdown options -->
        <mat-option
          *ngFor="let preference of userPreferences; trackBy: trackByPreferenceId"
          [value]="preference.id"
          class="preference-option"
        >
          <div class="preference-item">
            <span class="preference-name">{{ getName(preference.id) }}</span>

            <div class="preference-actions">
              <!-- DELETE -->
              <span (click)="deletePreference(preference, $event)" class="delete-btn">
                <mat-icon>delete</mat-icon>
              </span>
            </div>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  }
</div>
